import React from 'react';
import './SuccessPage.css';
import {FcCheckmark} from "react-icons/fc";
import {Button} from "./Button";
import {useTranslation} from '../i18n/LanguageProvider';
import {useSearchParams} from 'react-router-dom';

export const SuccessPage = () => {
    const {t} = useTranslation();
    const [searchParams] = useSearchParams();
    const isSuperlike = searchParams.get('productType') === 'superlike';
    return (
        <div className={'SuccessPage-container'}>
            <div className={'SuccessPage-header'}>
                <div className={'SuccessPage-checkmark'}>
                    <FcCheckmark
                        color={'#659C3A'}
                        size={25}
                    />
                </div>
                <h1 className={'SuccessPage-title'}>
                    {t(isSuperlike ? 'success.superlike.title' : 'success.title')}
                </h1>
            </div>
            <span className={'SuccessPage-subtitle'}>
                {t(isSuperlike ? 'success.superlike.subtitle' : 'success.subtitle')}
            </span>
            <Button
                onClick={() => window.location.replace('https://anonchat.com')}
                title={t('actions.goHome')}
            />
            <span className={'SuccessPage-subtitle-footer'}>
                {t('support.contactPrefix')}
                <a href={'https://anonchat.com/app'}>{t('support.anonchatLinkLabel')}</a>
                {t('support.contactMiddle')}
                <a href={'https://t.me/anonchatsupport'}>{t('support.telegramLinkLabel')}</a>
            </span>
        </div>
    );
};
